export default __webpack_public_path__ + "static/media/add-2.2fa93161.svg";